import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IFeature } from '../../../../types/project';
import * as styles from './FeatureMobile.css';

type IFeatureMobileProps = IFeature;

export const FeatureMobile: React.FC<IFeatureMobileProps> = ({ title, value }) => {
  return (
    <div className={styles['container']}>
      <UIText2 color="text-secondary-default">{title}</UIText2>
      <UIText2>{value}</UIText2>
    </div>
  );
};
